import styled from '@emotion/styled'

import { AllerganLogo, RitualLogo, ChopraLogo, AmbossLogo } from '@segment/matcha/components/CompanyLogos/Company'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

const copy = {
  description: `Innovative healthcare and life sciences organizations build personalized experience that improve outcomes with Segment.`,
}

const Logos = () => (
  <StyledSection variant="centered">
    <Section.Copy>
      <CopyTextBase>
        <CopyTextDescription variant="pMedium" tag="p">
          {copy.description}
        </CopyTextDescription>
      </CopyTextBase>
    </Section.Copy>
    <Section.Contents>
      <StyledColumnTrack overrides={{ xs: 2, md: 2, lg: 4 }} center={true}>
        <AllerganLogo />
        <AmbossLogo />
        <ChopraLogo />
        <RitualLogo />
      </StyledColumnTrack>
    </Section.Contents>
  </StyledSection>
)

const StyledSection = styled(SectionBase)`
  max-width: 524px;
  ${Section.Wrapper} {
    gap: 32px;
    ${({ theme }) => theme.breakpoints.up(`sm`)} {
      padding: 72px 0 44px;
    }
  }
`

const StyledColumnTrack = styled(ColumnTrack)`
  ${({ theme }) => theme.breakpoints.up(`md`)} {
    padding-left: 40px;
    padding-right: 40px;
  }
  column-gap: 24px;
`

const CopyTextDescription = styled(CopyText.Description)`
  ${({ theme }) => theme.breakpoints.up(`sm`)} {
    text-align: center;
  }
`

export default Logos
